module.exports = __webpack_public_path__ + "static/media/g1.881669e4.jpg";